import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('productSizes');

const actions = {
    requestFetchProductSizes: baseActions.request,
    fetchProductSizesSucceeded: baseActions.succeeded,
    fetchProductSizesFailed: baseActions.failed,
};

export { types, actions };

export default reducer;